module.exports = __webpack_public_path__ + "img/PM_5.e0fb1f27.svg";